import React from 'react';
import { connect } from 'react-redux';
import { link_click } from '../../../redux/actions';
import ReportLauncherPage from '../../ReportLauncher/ReportLauncherPage';
import buildRevenueMetricsReportsSections from './RevenueMetricsReportsSections';

class RevenueMetricsReportsAdmin extends React.Component {
  render() {
    return <ReportLauncherPage sections={buildRevenueMetricsReportsSections(this.props.link_click)} />;
  }
}

export default connect(null, { link_click })(RevenueMetricsReportsAdmin);
